import { Link, useLocation } from 'react-router-dom';
import { classicFor, NO_CLASSIC_WORDS } from '@/lib/v3-classic.js';

// "OPEN IN CLASSIC" on every v3 screen (V3 Overnight 3, lane C): the matching
// V2 screen, from the one table in lib/v3-classic.js. Where the subject has no
// V2 twin the words say why; there is never a link that opens nothing. Every
// v3 route's element renders this (guard: tests/v3-front-door.test.js).
export default function OpenInClassic({ payload, className = '' }) {
  const { pathname, search } = useLocation();
  const c = classicFor(pathname, search, payload);
  if (!c) return null;
  if (!c.href) return <span className={`text-xs text-text-dim ${className}`} data-open-in-classic data-classic-reason={c.reason}>{NO_CLASSIC_WORDS[c.reason] || NO_CLASSIC_WORDS.not_loaded}</span>;
  return (
    <Link to={c.href} className={`inline-flex min-h-[36px] items-center text-xs text-text-dim underline-offset-2 hover:text-text hover:underline ${className}`} data-open-in-classic data-classic-href={c.href}>
      {c.label || 'Open in classic'}
    </Link>
  );
}
